// src/services/financeiro/DashFinanceiroService.js
import { fetchData } from '../Api';
import DashFinanceiro from '../../models/financeiro/DashFinanceiro';

export const buscarDashFinanceiro = async (filialId, periodo) => new DashFinanceiro(await fetchData('/DashFinanceiro', {
  FilialId: filialId,
  DataIni: periodo.dataIni,
  DataFim: periodo.dataFim,
}));
